export function transformValidateRoutingNumberApiResponse(response) {
	return response.data;
}
